export enum TabKeys {
  /**
   * 文生图
   */
  TEXT_2_IMAGE = 'text2Image',
  /**
   * 款式延伸
   */
  STYLE_EXTENSION = 'styleextension',
  /**
   * 款式融合
   */
  STYLE_FUSION = 'styleblending',
  /**
   * 线稿生款
   */
  ORIGINALITY = 'sketch2image',
  /**
   * 微调
   */
  TUNE = 'inpaint',
  /**
   * 上色
   */
  RECOLOR = 'native_recolor',
  /**
   * 简单模式
   */
  EASY = 'easy',
  /**
   * 高级模式
   */
  ADVANCED = 'advanced',
  /**
   * AI 换场景
   */
  BACKGROUND = 'native_backgroundGenerate',
  /**
   * 一键抠图
   */
  ERASER = 'native_rembg',
  /**
   * 魔术擦除
   */
  CUTOUT = 'native_objectRemoval',
  /**
   * 高清生成
   */
  HD = 'native_upscale',
  /**
   * 实时设计
   */
  DRAWING = 'realtime_design',
  /**
   * 花型扩图
   */
  FLOWER_PATTERN_EXPANSION = 'native_seamlessTile',
  /**
   * AI扩图
   */
  AI_EXPANSION = 'native_imageExtend',
  /**
   * 图案生成
   */
  PATTERN = 'native_pattern',
  /**
   * 模特试衣
   */
  MODEL_TRY_ON = 'native_tryOn',
  /**
   * 模特试衣
   */
  MODEL_FACE = 'native_swapFace',
  /**
   * 图案提取
   */
  PATTERN_EXTRACTION = 'native_patternExtraction',
  /**
   * 服装提取
   */
  CLOTHING_EXTRACTION = 'native_clothingExtraction',
  /**
   * 材质转换
   */
  MATERIAL_CONVERSION = 'native_materialConversion',
  /**
   * 款式图上印花
   */
  STYLE_IMAGE_PRINTING = 'native_style_image_printing',
  /**
   * 款式图
   */
  STYLE_PICTURE = 'native_style_picture',
}
